import { doc, setDoc } from '@firebase/firestore';
import { Fragment, useEffect, useState } from 'react';
import { database } from '../firebase';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { useTranslation } from 'react-i18next';

const EditRecipeForm = ({ recipe }) => {
  const { t } = useTranslation();

  const [titleState, setTitleState] = useState(recipe.title);
  const [markupState, setMarkupState] = useState(recipe.markup);
  const [weightState, setWeightState] = useState(recipe.standardWeightInGrams);
  const [ingNameState, setIngNameState] = useState('');
  const [ingPercentageState, setIngPercentageState] = useState('');

  const [ingredientsState, setIngredientsState] = useState(recipe.ingredients);

  const editRecipe = event => {
    event.preventDefault();

    setDoc(doc(database, 'recipes', recipe.id), {
      id: recipe.id,
      date: recipe.date ? recipe.date : '',
      title: titleState,
      markup: markupState,
      path: `/${recipe.id}`,
      standardWeightInGrams: weightState,
      ingredients:
        ingNameState && ingPercentageState
          ? [
              ...ingredientsState,
              { name: ingNameState, percentage: ingPercentageState }
            ]
          : ingredientsState
    });

    setTimeout(() => {
      setTitleState(recipe.title);
      setMarkupState(recipe.markup);
      setWeightState(recipe.standardWeightInGrams);
      setIngredientsState(recipe.ingredients);
      setIngNameState('');
      setIngPercentageState('');
    });
  };

  useEffect(() => {
    setTitleState(recipe.title);
    setMarkupState(recipe.markup);
    setWeightState(recipe.standardWeightInGrams);
    setIngredientsState(recipe.ingredients);
    setIngNameState('');
    setIngPercentageState('');
  }, [recipe]);

  return (
    <>
      <h2>{t('editRecipe')}</h2>
      <form onSubmit={editRecipe}>
        <label htmlFor="title">{t('title')}</label>
        <input
          type="text"
          name="title"
          id="title"
          required
          value={titleState}
          onChange={e => setTitleState(e.target.value)}
        />
        <br />
        <br />
        <CKEditor
          editor={ClassicEditor}
          onChange={(event, editor) => {
            const data = editor.getData();
            setMarkupState(data);
          }}
          data={markupState}
        />
        <br />
        <br />
        <label htmlFor="weight">{t('weight')}</label>
        <input
          type="number"
          name="weight"
          id="weight"
          required
          value={weightState}
          onChange={e => setWeightState(e.target.value)}
        />
        <br />
        <br />
        <div className="ingredients-form-wrapper">
          <h3>{t('ingredients')}</h3>
          {ingredientsState.map((ing, index) => (
            <Fragment key={index}>
              <label htmlFor="ingredient-name">{t('ingredientColon')}</label>
              <input
                type="text"
                name="ingredient-name"
                id="ingredient-name"
                value={ing.name}
                onChange={e => {
                  setIngredientsState(prevState => {
                    const newArr = [];
                    prevState.forEach(item => {
                      if (item.name === prevState[index].name) {
                        newArr.push({
                          name: e.target.value,
                          percentage: item.percentage
                        });
                      } else {
                        newArr.push(item);
                      }
                    });

                    return newArr;
                  });
                }}
              />
              <br />
              <label htmlFor="ingredient-percentage">
                {t('percentageColon')}
              </label>
              <input
                type="number"
                name="ingredient-percentage"
                id="ingredient-percentage"
                value={ing.percentage}
                onChange={e => {
                  setIngredientsState(prevState => {
                    const newArr = [];
                    prevState.forEach(item => {
                      if (item.name === prevState[index].name) {
                        newArr.push({
                          name: item.name,
                          percentage: e.target.value
                        });
                      } else {
                        newArr.push(item);
                      }
                    });

                    return newArr;
                  });
                }}
              />
              <br />
              <br />
            </Fragment>
          ))}
          <label htmlFor="ingredient-name">{t('ingredient')}</label>
          <input
            type="text"
            name="ingredient-name"
            id="ingredient-name"
            value={ingNameState}
            onChange={e => setIngNameState(e.target.value)}
          />
          <br />
          <label htmlFor="ingredient-percentage">{t('percentage')}</label>
          <input
            type="number"
            name="ingredient-percentage"
            id="ingredient-percentage"
            value={ingPercentageState}
            onChange={e => setIngPercentageState(e.target.value)}
          />
          <br />
          <br />
          <button
            onClick={e => {
              e.preventDefault();
              if (ingNameState && ingPercentageState) {
                setIngredientsState(prevState => [
                  ...prevState,
                  { name: ingNameState, percentage: ingPercentageState }
                ]);
                setTimeout(() => {
                  setIngNameState('');
                  setIngPercentageState('');
                });
              }
            }}
          >
            {t('addIngredient')}
          </button>
          <br />
          <br />
        </div>
        <br />
        <button
          type="submit"
          disabled={
            !ingredientsState.length && (!ingNameState || !ingPercentageState)
          }
        >
          {t('submit')}
        </button>
      </form>
    </>
  );
};

export default EditRecipeForm;
